import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { RegistrationsDefaultCode } from '@/types/Register';
import { Form, Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

interface Props {
  hasItem?: boolean;
  index: number;
}

const MechanicsRecordParts = ({ hasItem, index }: Props) => {
  const { data: matrixData } = useMatrix();

  function getCode() {
    if (!matrixData?.matrixSettings?.defaultPartCode) {
      return 'sku';
    }

    switch (matrixData.matrixSettings.defaultPartCode) {
      case RegistrationsDefaultCode.manufacturerCode:
        return 'manufacturingCode';
      case RegistrationsDefaultCode.barCode:
        return 'barcode';
      case RegistrationsDefaultCode.companyCode:
        return 'companyCode';
      case RegistrationsDefaultCode.internalCode:
        return 'sku';
      default:
        return 'internalCode';
    }
  }

  return (
    <div className="part-card">
      <table>
        <thead>
          <tr>
            <th>Qtde./Tempo</th>
            <th>Descrição do item</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <Form.Item noStyle name={['items', `${index}`, 'quantity']}>
                <Input type="number" />
              </Form.Item>
            </td>

            <td>
              <Form.Item noStyle name={['items', `${index}`, 'description']}>
                <TextArea rows={2} />
              </Form.Item>
            </td>
          </tr>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th>Código</th>
            <th>Solução </th>
            <th>Motivo da troca</th>
            <th>Evidência</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            {!hasItem &&
              Array.from({ length: 3 }).map((_, index) => (
                <td key={index}>
                  <TextArea rows={1} />
                </td>
              ))}

            {hasItem && (
              <>
                <td key={0}>
                  <Form.Item
                    noStyle
                    name={['items', `${index}`, `${getCode()}`]}
                  >
                    <TextArea rows={1} />
                  </Form.Item>
                </td>

                <td key={1}>
                  <TextArea rows={1} />
                </td>

                <td key={2}>
                  <TextArea rows={1} />
                </td>
              </>
            )}

            <td>
              <span>
                <label>
                  <span style={{ marginRight: 2 }}>FOTO:</span>
                  <input type="checkbox" />
                </label>

                <label>
                  <span style={{ marginRight: 2 }}>VÍDEO:</span>
                  <input type="checkbox" />
                </label>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MechanicsRecordParts;
